import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import messages from "../../../redux/messages";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import CustomNavbar from "../../../components/CustomNavbar";
// import SidebarCapacitacion from "../../../components/capacitacionDesarrollo/SidebarCapacitacion";

//redux
import {
  deleteFormalEducationMetrics,
  editFormalEducationMetrics,
  getFormalEducationMetrics,
  saveFormalEducationMetrics,
} from "../../../redux/capacitacionDesarrollo/formal_education_metrics/actions";
import SidebarNueveCajas from "../../../components/nueveCajas/SidebarNueveCajas";

const FormalEducationMetrics = (props) => {
  const schema = Yup.object().shape({
    nombre_metrica: Yup.string().ensure().required("**Campo requerido"),
    anio: Yup.number()
      .integer("El número no puede tener decimales.")
      .min(2000, "El valor minimo es 0.")
      .required("**Campo requerido"),
    porcentaje: Yup.number()
      .min(0, "El valor minimo es 0")
      .required("**Campo requerido"),
  });

  const {
    loaderFormalEducationMetrics,
    formalEducationMetrics,
    formalEducationMetricsAnio,
    formalEducationMetricsAll,
    formalEducationMetricsFail,
    saveLoaderFormalEducationMetrics,
    formalEducationMetricsFormError,
  } = useSelector((store) => store.formalEducationMetrics);

  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);
  const [showFormModal, setShowFormModal] = useState(false);
  //
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  //
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");
  const dispatch = useDispatch();
  const fecha = new Date();
  const anioActual = fecha.getFullYear();
  const [_anio, setAnio] = useState(anioActual);

  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre_metrica",
    desc: "Métrica",
  });
  const filters = [
    // { id: "fecha_creacion", desc: "Fecha de creación" },
    { id: "nombre_metrica", desc: "Métrica" },
    { id: "porcentaje", desc: "Porcentaje" },
  ];

  const pages = Math.ceil(
    formalEducationMetrics ? formalEducationMetrics.count / limit : 0
  );
  //Datos custom table
  const columns = [
    {
      Header: "Métrica educación formal",
      accessor: "nombre_metrica",
    },
    {
      Header: "Porcentaje",
      accessor: "porcentaje",
    },
    {
      Header: "Fecha de creación",
      accesor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  //methods
  const _getFormalEducationMetrics = (
    offs = offset,
    lim = limit,
    filt = filter,
    ani = _anio
  ) =>
    dispatch(
      getFormalEducationMetrics({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter: filt,
        filter_2: ani,
      })
    );

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteFormalEducationMetrics(id, data));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getFormalEducationMetrics(oOffset, limit, oSearch);
  };

  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getFormalEducationMetrics(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = (req) => {
    //  const exist = trainings.data.find((e) => e.nombre_capacitacion === req.nombre_capacitacion);
    // const codExist = trainings.data.find((e) => e.codigo_capacitacion === req.codigo_capacitacion);
    //  if (codExist) {
    //    toastr.info("El código ya existe.");
    //    return;
    //   }
    if (!edit) {
      //   if(codExist){
      //     toastr.info("El código ya existe.");
      //     return;
      //   }

      dispatch(saveFormalEducationMetrics(req, setShowFormModal));
    } else {
      req.id = editItem.id;
      dispatch(editFormalEducationMetrics(req, index, setShowFormModal));
    }
  };

  useEffect(() => {
    // if (
    //   formalEducationMetricsAll &&
    //   formalEducationMetricsAll.data &&
    //   formalEducationMetricsAll.data[formalEducationMetricsAll.count - 1]
    // ){
    _getFormalEducationMetrics();
  }, [_anio]);

  // useEffect(() => {
  //   if (
  //     formalEducationMetricsAll &&
  //     formalEducationMetricsAll.data &&
  //     formalEducationMetricsAll.data[formalEducationMetricsAll.count - 1]
  //   ) {
  //     setInicialValorMinimo(
  //       formalEducationMetricsAll.data[formalEducationMetricsAll.count - 1].valor_maximo + 1
  //     );
  //   }
  // }, [formalEducationMetricsAll]);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarNueveCajas show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              MÉTRICAS DE ECUCACIÓN FORMAL
            </h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>

                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>

                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          <div className="px-2">
            <hr />
          </div>
          <Col>
            <Row>
              <Form.Group as={Col} md={5} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Año
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loaderFormalEducationMetrics ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="aniio"
                          name="aniio"
                          className="col rounded-pill"
                          defaultValue={_anio}
                          disabled={loaderFormalEducationMetrics}
                          onChange={(e) => {
                            e.preventDefault();
                            if (e.currentTarget.value !== "") {
                              setAnio(parseInt(e.currentTarget.value));
                            } else {
                              setAnio(anioActual);
                            }
                          }}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            // disabled
                          ></option>
                          {formalEducationMetricsAnio &&
                            formalEducationMetricsAnio.data
                              .sort((a, b) =>
                                a.anio > b.anio ? 1 : b.anio > a.anio ? -1 : 0
                              )
                              .map((item) => (
                                <option key={item.anio} value={item.anio}>
                                  {item.anio}
                                </option>
                              ))}
                        </Form.Control>
                      </Col>
                      {loaderFormalEducationMetrics ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
            </Row>
          </Col>
          {!!formalEducationMetricsFail && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {formalEducationMetricsFail}
            </Alert>
          )}
          {loaderFormalEducationMetrics ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : formalEducationMetrics != null &&
            formalEducationMetrics.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable
                    columns={columns}
                    data={formalEducationMetrics.data}
                  />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={formalEducationMetrics.count}
                pages={pages}
                pagFunc={_getFormalEducationMetrics}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
        </Container>
        {/*Modal editar*/}
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              nombre_metrica: edit ? editItem.nombre_metrica : "",
              //descripcion: edit ? editItem.descripcion : "",
              porcentaje: edit ? editItem.porcentaje : "",
              anio: edit ? editItem.anio : anioActual,
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              //setFieldValue,
              values,
              touched,
              //isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit
                      ? "Editar métrica de educación"
                      : "Crear métrica de educación"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {formalEducationMetricsFormError &&
                  typeof formalEducationMetricsFormError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2">
                      {formalEducationMetricsFormError}
                    </Alert>
                  ) : null}
                  {!edit && _anio !== anioActual && (
                    <Alert variant="info" className="mt-1 mb-2">
                      El año seleccionado previamente, debe ser igual al año
                      seleccionado en el formulario o estar vacio.
                    </Alert>
                  )}
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Métrica de educación formal
                    </Form.Label>
                    <Form.Control
                      name="nombre_metrica"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.nombre_metrica}
                      placeholder="Métrica"
                      onBlur={handleBlur("nombre_metrica")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={
                        touched.nombre_metrica && !!errors.nombre_metrica
                      }
                      disabled={!edit && _anio !== anioActual}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre_metrica}
                    </Form.Control.Feedback>
                    {formalEducationMetricsFormError &&
                    typeof formalEducationMetricsFormError === "object" &&
                    formalEducationMetricsFormError.nombre_metrica ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formalEducationMetricsFormError.nombre_metrica.map(
                          (item) => (
                            <li>{item}</li>
                          )
                        )}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Porcentaje
                    </Form.Label>
                    <Form.Control
                      name="porcentaje"
                      className="rounded-pill"
                      required
                      type="float"
                      value={values.porcentaje}
                      placeholder="porcentaje"
                      onBlur={handleBlur("porcentaje")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.porcentaje && !!errors.porcentaje}
                      disabled={!edit && _anio !== anioActual}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.porcentaje}
                    </Form.Control.Feedback>
                    {formalEducationMetricsFormError &&
                    typeof formalEducationMetricsFormError === "object" &&
                    formalEducationMetricsFormError.porcentaje ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formalEducationMetricsFormError.porcentaje.map(
                          (item) => (
                            <li>{item}</li>
                          )
                        )}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Año
                    </Form.Label>
                    <Form.Control
                      id="anio"
                      name="anio"
                      isInvalid={touched.anio && errors.anio}
                      isValid={touched.anio && !errors.anio}
                      onBlur={handleBlur("anio")}
                      onChange={handleChange}
                      value={values.anio}
                      className="rounded-pill"
                      type="number"
                      placeholder="2000"
                      min={2000}
                      disabled
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.anio}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cerrar
                  </Button>
                  {(!edit && _anio === anioActual) || edit ? (
                    <Button
                      className="rounded-pill"
                      disabled={saveLoaderFormalEducationMetrics}
                      variant="primary"
                      type="submit"
                    >
                      {saveLoaderFormalEducationMetrics && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      Guardar
                    </Button>
                  ) : null}
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
      </div>
    </>
  );
};

export default FormalEducationMetrics;
